export default "__VITE_ASSET__41a20c91__"